export enum ResearchStatus {
  Draft = 1,
  Live = 2,
  Offline = 3,
  Closed = 4,
  LiveEditing = 5
}
